/* Ardor A-Frame Sign Builder: the AI design drawer ("AI design" on the tool rail). Ardor Printing. New Oct 11, 2026 (AI-AFRAME).
Builds its form inside the drawer panel that assets/ardor-aframe-ai-layers.js adds ([data-aai-host]). Same flow and look as the
flag designer's AI drawer (assets/ardor-flag-ai.js), and the same AI server requests as the AI A-frame sign generator page
(assets/ardor-aframe-idea.js, /pages/ai-a-frame-sign-generator), no server change: POST /api/banner/logo, /api/banner/generate
(product "aframe"; 24 x 36 in = widthFt 2, heightFt 3; 22 x 28 in = widthFt 22/12, heightFt 28/12), /api/banner/final
(product "aframe"), GET /api/banner/quota, with the same visitor id / email (localStorage wsIdeaVisitor / wsIdeaEmail), the same
email unlock (newsletter sign-up through the Shopify customer form #aai-customer in the section) and the same invisible
Cloudflare Turnstile check, so tries are shared with the AI pages. The size asked for is the sign size of the frame picked in
the builder. The picked design is made print-ready (/final) and handed to ArdorAFrameLayers.placeAi(), the same placement as
the AI page hand-off (Fill mode; the design already has the sign's shape). Where it goes: the front, so with 2 signs and
"Same on both sides" it is on both sides (Dayne's Oct 8 choice); with 2 signs and "Different back" it goes on the side being
designed. Quota and Turnstile load the first time the drawer opens. */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__aai) return;
  root.__aai = true;

  var CONF = {};
  try { CONF = JSON.parse(root.querySelector('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  var API_BASE = String(CONF.ideaApi || 'https://ws-idea-api.dayne-18a.workers.dev').replace(/\/+$/, '');
  var SITEKEY = String(CONF.turnstile || '');
  var AI_PAGE = String(CONF.ideasUrl || '/pages/ai-a-frame-sign-generator');
  var LIMITS = { headline: 60, subline: 80, details: 120, notes: 300 };
  var STYLES = [['bold', 'Bold'], ['clean', 'Clean'], ['fun', 'Fun'], ['elegant', 'Elegant'], ['vintage', 'Vintage'], ['event', 'Event']];
  // the two A-frame sign sizes the AI server makes (inches -> feet, as the AI page sends them)
  var SIZES = { '24x36': { w: 2, h: 3, label: '24 x 36 in' }, '22x28': { w: 22 / 12, h: 28 / 12, label: '22 x 28 in' } };
  var MAX_LOGO_PX = 1536, MAX_LOGO_BYTES = 8 * 1024 * 1024, MAX_SOURCE_BYTES = 30 * 1024 * 1024;
  var DOT = ' \u00b7 ', ELL = '\u2026';
  var OFF_MSG = 'AI design is taking a short break. Please try again later.';
  var TAGS = 'newsletter,ai-aframe-generator,ardor-aframe-builder';

  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) {} return null; }
  var visitor = store('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    store('wsIdeaVisitor', visitor);
  }
  var email = store('wsIdeaEmail') || '';
  var S = { style: 'bold', logo: null, logoId: '', busy: false, left: null, hasEmail: false, emailTries: 10, batch: null, timer: 0, off: false, opened: false, retry: null };
  var ui = {};

  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || ui.host || document).querySelector(s); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clean(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }
  function validBox(lb) { return Array.isArray(lb) && lb.length === 4 && lb.every(function (n) { return typeof n === 'number' && isFinite(n); }) ? lb.map(function (n) { return Math.min(1, Math.max(0, n)); }) : null; }
  function track(name, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {} }
  function AA() { return window.ArdorAFrameAPI; }
  function LY() { return window.ArdorAFrameLayers; }
  function msgOf(j, fallback) { return j && j.error === 'off' ? OFF_MSG : (j && j.message) || fallback; }

  // ---------- the sign being designed: what size to ask for and which side the design goes on ----------
  function plan() {
    var A = AA(), c = A.cfg(), st = A.state || {};
    var key = c.Wi === 22 && c.Hi === 28 ? '22x28' : '24x36';
    var diff = c.sides === 2 && st.backMode === 'different';
    var face = diff && A.editFace() === 'back' ? 'back' : 'front';
    return { c: c, key: key, size: SIZES[key], face: face, both: c.sides === 2 && !diff, diff: diff, name: (c.model && c.model.name) || 'A-frame sign' };
  }

  // ---------- server ----------
  function api(path, body, ms) {
    var opts = {};
    if (body instanceof FormData) { opts.method = 'POST'; opts.body = body; }
    else if (body) { opts.method = 'POST'; opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    var ctl = window.AbortController ? new AbortController() : null, t = 0;
    if (ctl) { opts.signal = ctl.signal; t = setTimeout(function () { ctl.abort(); }, ms || 180000); }
    return fetch(API_BASE + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        clearTimeout(t);
        if (!j || typeof j !== 'object') j = {};
        if (r.status === 402 && !j.error) j.error = 'need_email';
        if (!r.ok) { if (!j.error) j = { ok: false, error: 'server', message: 'Something went wrong on our side. Please try again.' }; j.ok = false; }
        return j;
      });
    }, function (e) {
      clearTimeout(t);
      return e && e.name === 'AbortError' ? { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' } : { ok: false, error: 'network', message: 'Check your connection and try again.' };
    });
  }
  function withEmail(b) { if (S.hasEmail && email) b.email = email; return b; }
  function quota() {
    var q = 'visitor=' + encodeURIComponent(visitor) + (email ? '&email=' + encodeURIComponent(email) : '');
    return fetch(API_BASE + '/api/banner/quota?' + q).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.ok) {
        S.left = j.bannersLeft; S.hasEmail = !!j.hasEmail; S.emailTries = j.emailBanners || S.emailTries;
        if (j.enabled === false) S.off = true;
      }
      syncQuota();
    }).catch(function () {});
  }

  // ---------- Turnstile: explicit render, invisible, a fresh token for every request ----------
  var tsReady = null, tsWidget = null, tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise(function (res) {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.aaiTurnstileLoaded = function () { res(true); };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=aaiTurnstileLoaded';
      s.async = true; s.defer = true;
      s.onerror = function () { tsReady = null; res(false); };
      document.head.appendChild(s);
    });
    return tsReady;
  }
  function botToken() {
    return loadTurnstile().then(function (ok) {
      if (!ok || !window.turnstile) return '';
      return new Promise(function (res) {
        tsResolve = res;
        var take = function (t) { var r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
        try {
          if (tsWidget === null) tsWidget = window.turnstile.render($('[data-aai-ts]'), { sitekey: SITEKEY, execution: 'execute', appearance: 'interaction-only', callback: take, 'error-callback': function () { take(''); } });
          else window.turnstile.reset(tsWidget);
          window.turnstile.execute(tsWidget);
        } catch (e) { take(''); }
        setTimeout(function () { if (tsResolve === res) take(''); }, 45000);
      });
    });
  }

  // ---------- logo: any picture, made a PNG up to 1536 px for the AI ----------
  function toPng(file) {
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () {
        var w = im.naturalWidth || 800, h = im.naturalHeight || 800, k = Math.min(1, MAX_LOGO_PX / Math.max(w, h));
        var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(w * k)); cv.height = Math.max(1, Math.round(h * k));
        cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height);
        URL.revokeObjectURL(u);
        cv.toBlob(function (b) { if (b) res(b); else rej(new Error('png')); }, 'image/png');
      };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
      im.src = u;
    });
  }
  function uploadLogo() {
    if (!S.logo) return Promise.resolve('');
    if (S.logoId) return Promise.resolve(S.logoId);
    return toPng(S.logo).then(function (b) {
      if (b.size > MAX_LOGO_BYTES) throw { message: 'Your logo is too big. Try a smaller file.' };
      var fd = new FormData(); fd.append('file', b, 'logo.png'); fd.append('visitor', visitor);
      return api('/api/banner/logo', fd, 60000);
    }, function () { throw { message: 'We couldn\'t read that logo. Upload a PNG, JPG or SVG file.' }; }).then(function (j) {
      if (!j.ok || !j.logoId) throw j;
      S.logoId = j.logoId; return j.logoId;
    });
  }

  // ---------- email unlock: same as the AI A-frame sign generator page (newsletter sign-up + more tries) ----------
  function customerForm() {
    var f = document.getElementById('aai-customer');
    if (!f) {
      f = document.createElement('form');
      f.id = 'aai-customer'; f.method = 'post'; f.action = '/contact#aai-customer'; f.className = 'aai-customer'; f.hidden = true;
      f.innerHTML = '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="\u2713"><input type="hidden" name="contact[tags]" value="' + TAGS + '"><input type="hidden" name="contact[email]" data-aai-customer-email>';
      document.body.appendChild(f);
    }
    if (!document.querySelector('iframe[name="aai-sink"]')) {
      var fr = document.createElement('iframe');
      fr.name = 'aai-sink'; fr.title = 'Email signup'; fr.className = 'aai-sink'; fr.tabIndex = -1; fr.setAttribute('aria-hidden', 'true'); fr.hidden = true;
      document.body.appendChild(fr);
    }
    return f;
  }
  function subscribe(addr) {
    var f = customerForm();
    var field = f.querySelector('[name="contact[email]"]');
    if (field) field.value = addr;
    f.target = 'aai-sink';
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (e2) {} }
  }

  // ---------- UI ----------
  function build(host) {
    ui.host = host;
    host.innerHTML =
      '<div class="aai">' +
      '<p class="abl-help aai-lead">Type your words and pick a style. Our AI draws 4 designs in your sign size (<b data-aai-size>24 x 36 in</b>). Tap one to put it on your sign, then move or resize it.</p>' +
      '<p class="aai-where" data-aai-where hidden></p>' +
      '<label class="aai-field"><span>Main words <em>(required)</em></span><input class="abl-input aai-in" data-aai-line="headline" maxlength="' + LIMITS.headline + '" placeholder="For example: OPEN TODAY" autocomplete="off"></label>' +
      '<label class="aai-field"><span>Second line <em>(optional)</em></span><input class="abl-input aai-in" data-aai-line="subline" maxlength="' + LIMITS.subline + '" placeholder="For example: Fresh coffee and pastries" autocomplete="off"></label>' +
      '<label class="aai-field"><span>Details <em>(optional)</em></span><input class="abl-input aai-in" data-aai-line="details" maxlength="' + LIMITS.details + '" placeholder="Phone, website, hours or an arrow" autocomplete="off"></label>' +
      '<div class="aai-field"><span>Style</span><div class="aai-styles" data-aai-styles></div></div>' +
      '<label class="aai-field"><span>Colors, pictures or mood <em>(optional)</em></span><textarea class="abl-input aai-in aai-notes" rows="2" data-aai-notes maxlength="' + LIMITS.notes + '" placeholder="For example: black and gold, a coffee cup"></textarea></label>' +
      '<div class="aai-field"><span>Your logo <em>(optional)</em></span><div class="aai-logo"><input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" data-aai-logo-in hidden><button type="button" class="aai-btn aai-btn--ghost" data-aai-logo-btn>Add your logo</button><span class="aai-logo__name" data-aai-logo-name></span><button type="button" class="aai-x" data-aai-logo-x hidden aria-label="Remove the logo">&times;</button></div></div>' +
      '<div class="aai-gate" data-aai-gate hidden><p class="abl-help">You\'ve used today\'s free tries. Add your email to unlock <span data-aai-gate-n>10</span> design tries a day (4 designs each). We\'ll send you sign and print deals too.</p><div class="aai-gate__row"><input class="abl-input aai-in" type="email" data-aai-email placeholder="you@example.com" autocomplete="email" aria-label="Your email"><button type="button" class="aai-btn" data-aai-email-go>Unlock</button></div><p class="aai-fine">By continuing you agree to get emails from Ardor Printing. Unsubscribe anytime.</p></div>' +
      '<p class="aai-err" data-aai-err role="alert" hidden></p>' +
      '<button type="button" class="aai-btn aai-btn--go" data-aai-go>Design my sign</button>' +
      '<p class="aai-quota" data-aai-quota></p>' +
      '<div class="aai-status" data-aai-status aria-live="polite" hidden></div>' +
      '<div class="aai-results" data-aai-results></div>' +
      '<div class="aai-ts" data-aai-ts></div>' +
      '<p class="abl-help aai-more">Want more room to try ideas? <a data-aai-page href="' + esc(AI_PAGE) + '">Open the full AI generator</a>.</p>' +
      '</div>';
    var st = $('[data-aai-styles]');
    STYLES.forEach(function (s) {
      var b = el('button', 'aai-chip', esc(s[1])); b.type = 'button'; b.setAttribute('data-aai-s', s[0]); b.setAttribute('aria-pressed', s[0] === S.style ? 'true' : 'false');
      st.appendChild(b);
    });
    host.addEventListener('click', onClick);
    $('[data-aai-logo-in]').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; e.target.value = '';
      if (!f) return;
      if (f.size > MAX_SOURCE_BYTES) { showErr('That logo file is too big. Try one under 30 MB.'); return; }
      S.logo = f; S.logoId = ''; syncLogo();
    });
    host.addEventListener('input', function () { showErr(''); });
    syncPlan(); syncLogo();
    // the size, sides or face may change in the builder: keep the drawer's words in step; quota + Turnstile on first open
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-abl-tool="ai"], [data-abl-idea]')) setTimeout(onOpen, 0);
      setTimeout(syncPlan, 0);
    });
    root.addEventListener('change', function () { setTimeout(syncPlan, 0); });
  }
  function onOpen() {
    syncPlan();
    if (S.opened) return;
    S.opened = true;
    quota();
    if (SITEKEY) loadTurnstile();
  }
  function onClick(e) {
    var b = e.target.closest('button, a'); if (!b) return;
    if (b.hasAttribute('data-aai-s')) { S.style = b.getAttribute('data-aai-s'); [].forEach.call(ui.host.querySelectorAll('[data-aai-s]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); return; }
    if (b.hasAttribute('data-aai-logo-btn')) { $('[data-aai-logo-in]').click(); return; }
    if (b.hasAttribute('data-aai-logo-x')) { S.logo = null; S.logoId = ''; syncLogo(); return; }
    if (b.hasAttribute('data-aai-go')) { generate(); return; }
    if (b.hasAttribute('data-aai-email-go')) { useEmail(); return; }
    if (b.hasAttribute('data-aai-use')) { useDesign(b.getAttribute('data-aai-use')); return; }
    if (b.hasAttribute('data-aai-page')) { var p = plan(); b.href = AI_PAGE + (AI_PAGE.indexOf('?') < 0 ? '?' : '&') + 'size=' + p.key; }
  }
  function syncPlan() {
    if (!ui.host || !AA()) return;
    var p = plan(), sz = $('[data-aai-size]'), w = $('[data-aai-where]');
    if (sz) sz.textContent = p.size.label;
    if (!w) return;
    var t = p.both ? 'You have 2 signs with the same art, so the design goes on both sides.' : p.diff ? (p.face === 'back' ? 'The design goes on the back, the side you are designing now.' : 'The design goes on the front. To design the back, switch to the back first.') : '';
    w.textContent = t; w.hidden = !t;
  }
  function syncLogo() {
    $('[data-aai-logo-name]').textContent = S.logo ? S.logo.name : '';
    $('[data-aai-logo-x]').hidden = !S.logo;
    $('[data-aai-logo-btn]').textContent = S.logo ? 'Change logo' : 'Add your logo';
  }
  function syncQuota() {
    var q = $('[data-aai-quota]'); if (!q) return;
    var n = $('[data-aai-gate-n]'); if (n) n.textContent = String(S.emailTries);
    if (S.off) { q.textContent = OFF_MSG; $('[data-aai-go]').disabled = true; return; }
    if (S.left == null) { q.textContent = ''; return; }
    var k = S.left;
    if (S.hasEmail) q.textContent = k > 0 ? k + (k === 1 ? ' try' : ' tries') + ' left today' : 'No tries left today';
    else q.textContent = k > 0 ? k + ' free ' + (k === 1 ? 'try' : 'tries') + DOT + '4 designs each' + DOT + 'no sign-up' : 'Add your email for ' + S.emailTries + ' tries a day';
  }
  function showErr(m) { var e = $('[data-aai-err]'); if (!e) return; e.textContent = m || ''; e.hidden = !m; }
  function busy(on, text) {
    S.busy = on;
    [].forEach.call(ui.host.querySelectorAll('button, input, textarea'), function (x) { x.disabled = on; });
    if (!on && S.off) $('[data-aai-go]').disabled = true;
    var s = $('[data-aai-status]'); clearInterval(S.timer);
    if (!on) { s.hidden = true; s.textContent = ''; $('[data-aai-go]').textContent = 'Design my sign'; return; }
    var t0 = Date.now();
    s.hidden = false;
    var tick = function () { s.textContent = text + ' ' + Math.round((Date.now() - t0) / 1000) + ' s'; };
    tick(); S.timer = setInterval(tick, 1000);
    $('[data-aai-go]').textContent = 'Designing' + ELL;
  }
  function readLines() {
    var L = {};
    [].forEach.call(ui.host.querySelectorAll('[data-aai-line]'), function (x) { var k = x.getAttribute('data-aai-line'), v = clean(x.value).slice(0, LIMITS[k]); if (v) L[k] = v; });
    return L;
  }
  function openGate(retry) {
    S.retry = retry || null;
    $('[data-aai-gate]').hidden = false;
    var e = $('[data-aai-email]'); if (e) { e.value = email || ''; try { e.focus(); } catch (er) {} }
    track('ardor_aframe_ai_gate_shown', { source: 'builder' });
  }
  function useEmail() {
    var v = clean($('[data-aai-email]').value);
    if (!validEmail(v)) { showErr('Please enter a valid email.'); return; }
    email = v; store('wsIdeaEmail', v); S.hasEmail = true;
    subscribe(v);
    track('ardor_aframe_ai_email', { source: 'builder' });
    $('[data-aai-gate]').hidden = true;
    showErr('');
    quota().then(function () { var r = S.retry; S.retry = null; if (r && !(r === generate && S.left === 0)) r(); });
  }

  // ---------- generate 4 designs, show them, make the picked one print-ready and put it on the sign ----------
  function generate() {
    if (S.busy || S.off) return;
    var lines = readLines();
    if (!lines.headline) { showErr('Type the main words for your sign.'); var h = $('[data-aai-line="headline"]'); if (h) h.focus(); return; }
    if (S.left === 0 && !S.hasEmail) { openGate(generate); return; }
    showErr('');
    var p = plan(), notes = clean($('[data-aai-notes]').value).slice(0, LIMITS.notes);
    busy(true, 'Designing your sign' + ELL + ' this takes about a minute.');
    uploadLogo().then(function (logoId) {
      return botToken().then(function (token) {
        var body = withEmail({ visitor: visitor, token: token, product: 'aframe', widthFt: p.size.w, heightFt: p.size.h, style: S.style, styleNotes: notes, lines: lines });
        if (logoId) body.logoId = logoId;
        return api('/api/banner/generate', body, 240000);
      });
    }).then(function (j) {
      busy(false);
      if (j.bannersLeft != null) S.left = j.bannersLeft;
      if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
      syncQuota();
      if (!j.ok || !j.images || !j.images.length) {
        if (j.error === 'need_email') { S.left = 0; syncQuota(); openGate(generate); return; }
        if (j.error === 'off') { S.off = true; syncQuota(); }
        showErr(msgOf(j, 'We couldn\'t make your designs this time. Please try again.'));
        return;
      }
      S.batch = { images: j.images.slice(0, 4), key: p.key, logoId: S.logoId || '', lines: lines, style: S.style };
      track('ardor_aframe_ai_generated', { source: 'builder', style: S.style, size: p.key, logo: !!S.logoId, shown: S.batch.images.length });
      showResults();
    }, function (err) {
      busy(false);
      showErr((err && err.message) || 'We couldn\'t upload your logo. Try another file, or remove it and try again.');
    });
  }
  function showResults() {
    var box = $('[data-aai-results]'), b = S.batch; box.textContent = '';
    if (!b) return;
    box.appendChild(el('p', 'abl-help', 'Tap a design to put it on your sign.'));
    var grid = el('div', 'aai-grid');
    b.images.forEach(function (im, i) {
      var card = el('button', 'aai-card');
      card.type = 'button'; card.setAttribute('data-aai-use', im.id); card.setAttribute('aria-label', 'Use design ' + (i + 1));
      card.innerHTML = '<span class="aai-card__img"><img alt="" loading="lazy" src="' + esc(im.url) + '"></span><span class="aai-card__go">Use this design</span>';
      grid.appendChild(card);
    });
    box.appendChild(grid);
  }
  function useDesign(id) {
    if (S.busy || !S.batch) return;
    var b = S.batch, img = b.images.filter(function (x) { return x.id === id; })[0];
    if (!img) return;
    showErr('');
    busy(true, 'Making a sharp, print-ready version' + ELL + ' about 30 to 60 seconds.');
    botToken().then(function (token) {
      return api('/api/banner/final', withEmail({ visitor: visitor, token: token, imageId: id, product: 'aframe' }), 420000);
    }).then(function (j) {
      if (!j.ok || !j.image || !j.image.id) {
        busy(false);
        if (j.error === 'need_email') { openGate(function () { useDesign(id); }); return; }
        showErr(msgOf(j, 'We couldn\'t make the print version. Please try again.'));
        return;
      }
      var fin = j.image, lb = validBox(fin.check && fin.check.logoBox) || validBox(img.check && img.check.logoBox);
      var L = LY();
      if (!L || !L.placeAi) { busy(false); showErr('Please reload the page and try again.'); return; }
      var p = plan();
      return L.placeAi({ id: fin.id, face: p.face, logo: b.logoId, lb: lb, source: 'drawer' }).then(function () {
        busy(false);
        track('ardor_aframe_ai_design_used', { source: 'builder', style: b.style, size: b.key, face: p.face, both: p.both, logo: !!b.logoId });
        if (L.closeDrawer) L.closeDrawer();
        var on = p.both ? 'Your AI design is on both sides of your sign.' : p.face === 'back' ? 'Your AI design is on the back of your sign.' : 'Your AI design is on your sign.';
        if (L.toast) L.toast(on + (b.logoId ? ' Tap "Use my exact logo" to put your original logo file over the AI\'s version.' : ' Drag it to move it, or add text and clipart.'), 9000);
      });
    }).catch(function () { busy(false); showErr('We couldn\'t put the design on your sign. Please try again.'); });
  }

  // ---------- start: wait for the builder, its layers and the drawer ----------
  var tries = 0;
  (function wait() {
    var host = root.querySelector('[data-aai-host]');
    if (host && AA() && LY() && LY().placeAi) { build(host); window.ArdorAFrameAI = { plan: plan, quota: quota, state: S, open: onOpen }; return; }
    if (++tries < 300) setTimeout(wait, 100);
  })();
})();
